import { useEffect, useState } from 'react';

import styles from './stylesTableTabs.module.css';

function TableTabs({ liveSports, onSelectSport }) {
  const [activeTab, setActiveTab] = useState();

  const [sportTabs, setSportTabs] = useState([]);

  useEffect(() => {
    if (!liveSports) return;
    setSportTabs(liveSports);
    setActiveTab(
      liveSports?.find(({ display_order }) => Number(display_order) === 1)
        .sport_id
    );
  }, [liveSports]);

  const handleSportClick = (id) => {
    setActiveTab(id);
    onSelectSport(id);
  };

  return (
    <div className={styles.tableTabs}>
      {sportTabs?.map((sport) => (
        <div
          key={sport.sport_id}
          data-id={sport.sport_id}
          data-order={sport.order}
          onClick={() => handleSportClick(sport.sport_id)}
          className={`${styles.tableTab} ${
            activeTab === sport.sport_id ? styles.active : ''
          }`}
        >
          <span>{sport.name}</span>
        </div>
      ))}
    </div>
  );
}

export default TableTabs;
